import {onCollapse, onExpand, reflow} from '../libs/utils'
export default new class {
    constructor() {
        this.init()
    }

    bindListeners() {
        document.addEventListener('click', (e) => {
            const button = e.target.closest('._collapse-button');
            if (button) {
                e.preventDefault();
                const header = button.closest('._collapse-header');
                if (header.classList.contains('_active')) {
                    this.hide(header)
                } else {
                    this.show(header);
                }
                // header.classList.add('_collapse-header_active');
                // header.nextElementSibling.classList.add('_collapse-body_active');
                return
            }
        })
    }

    show(header) {
        const body = header.nextElementSibling;

        header.dispatchEvent(new CustomEvent('onexpand', {bubbles: true}))
        header.classList.add('_active');
        body.classList.remove('_collapse-body');
        body.classList.add('_collapse-body_transition');
        body.addEventListener('transitionend', onExpand);
        body.style.height = 0;
        body.style.height = body.scrollHeight + 'px';
    }

    hide(header) {
        const body = header.nextElementSibling;

        header.dispatchEvent(new CustomEvent('oncollapse', {bubbles: true}))
        header.classList.remove('_active');
        body.style.height = body.getBoundingClientRect().height + 'px';
        reflow(body);
        body.classList.add('_collapse-body_transition');
        body.classList.remove('_active', '_collapse-body');
        body.addEventListener('transitionend', onCollapse);
        body.style.height = null;        
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.bindListeners();
        })
    }
}